import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { priceShow } from 'shared/lib/priceShow'
import { RangeInput } from 'shared/ui/range-input'

import { Props } from './module'
import s from './styles.module.scss'

export interface RangePrice {
  min: number
  max: number
}

export const InputRange: FC<Props> = ({
  label,
  title,
  min,
  max,
  value,
  onChange,
  showText,
}) => {
  const { t } = useTranslation()
  return (
    <div className={s.container}>
      <p className={clsx(s.title, 'bold-17')}>{title}</p>

      <div className={s.headerPrice}>
        <p className={clsx(s.left, 'medium-14')}>{label}</p>
        <p className={clsx(s.right, 'medium-13')}>
          {showText ? (
            t('tours_block.all_prices')
          ) : (
            <>
              <span>{priceShow(String(value?.[0]))} &#8384;</span>
              {' — '}
              <span>{priceShow(String(value?.[1]))} &#8384;</span>
            </>
          )}
        </p>
      </div>

      <RangeInput
        min={min}
        max={max}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}
